import { useRef, useState } from "react";

import { useMediaQuery } from "customHooks/useMediaQuery";

import "./style.scss";

const FeedbackContainer = () => {
	const [scrollX, setscrollX] = useState(0);
	const [scrollEnd, setscrolEnd] = useState(false);
	const listRef = useRef(null);
	const width = useMediaQuery();

	// button slide click

	const slide = (shift) => {
		listRef.current.scrollLeft += shift;
		setscrollX(scrollX + shift);

		if (
			Math.floor(listRef.current.scrollWidth - listRef.current.scrollLeft) <=
			listRef.current.offsetWidth
		) {
			setscrolEnd(true);
		} else {
			setscrolEnd(false);
		}
	};

	// check the scrollEnd
	const scrollCheck = () => {
		setscrollX(listRef.current.scrollLeft);
		if (
			Math.floor(listRef.current.scrollWidth - listRef.current.scrollLeft) <=
			listRef.current.offsetWidth
		) {
			setscrolEnd(true);
		} else {
			setscrolEnd(false);
		}
	};

	return (
		<section className="feedback">
			<div className="feedback__container">
				<script src="https://apps.elfsight.com/p/platform.js" defer></script>
				<div class="elfsight-app-3c3452a5-4186-4412-9143-3ddbf8b55279"></div>
				{/* <div className="feedback__header">
					<div className="feedback__header-title">
						<h2 className="feedback-title">
							They Love Our Homes As Much As You Do!
						</h2>
					</div>
					<div className="feedback__button">
						<span className="button-one" onClick={() => slide(-500)}>
							{scrollX === 0 ? (
								<SvgButtonArrowLeft
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
								/>
							) : (
								<SvgButtonArrowRight
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
									style={{ transform: "rotate(180deg)" }}
								/>
							)}
						</span>
						<span className="button-two" onClick={() => slide(500)}>
							{!scrollEnd ? (
								<SvgButtonArrowRight
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
								/>
							) : (
								<SvgButtonArrowLeft
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
									style={{ transform: "rotate(180deg)" }}
								/>
							)}
						</span>
					</div>
				</div>
				<div className="feedback__wrapper">
					<div
						className="feedback__wrapper-users"
						ref={listRef}
						onScroll={scrollCheck}
					>
						{feedbackData.map((user) => (
							<FeedbackCard
								id={user.id}
								img={user.img}
								name={user.name}
								influencerLink={user.influencerLink}
								villaLink={user.villaLink}
								// rating={user.rating}
								location={user.location}
								key={user.id}
							/>
						))}
					</div>
				</div> */}
			</div>
		</section>
	);
};

export default FeedbackContainer;
